import { Component, Input, OnInit } from '@angular/core';
import { ORDER_STATUS } from '../../../enums';

@Component({
  selector: 'app-order-status-view',
  templateUrl: './order-status-view.component.html',
  styleUrls: ['./order-status-view.component.scss'],
})
export class OrderStatusViewComponent implements OnInit {
  @Input() status: string;

  private readonly defaultConfig: { class: string[]; status?: string } = {
    class: ['order-status--default'],
  };

  statuses = {
    pending: {
      class: ['order-status--pending'],
      status: 'Pending',
    },
    draft: {
      class: ['order-status--draft'],
      status: 'Draft',
    },
    [ORDER_STATUS.PICKED_UP]: {
      class: ['order-status--pickedup'],
      status: 'Picked Up',
    },
    default: this.defaultConfig,
  };

  config: { class: string[]; status?: string } = this.defaultConfig;

  ngOnInit() {
    this.config = this.statuses[this.status];
    if (!this.config) {
      this.config = this.statuses['default'];
      this.config.status = this.status.toUpperCase();
    }
  }

  // QUOTE = 'new',
  // PUBLISHED = 'published',
  // DECLINED = 'declined',
  // CLAIMED = 'claimed',
  // DISPATCHED = 'dispatched',
  // CANCELED = 'canceled',
  // PAID = 'paid',
  // ON_PICKUP = 'on_pickup',
  // ON_WAY_TO_PICKUP = 'on_way_to_pickup',
  // PICKED_UP = 'picked_up',
  // ON_DELIVERY = 'on_delivery',
  // DELIVERED = 'delivered',
  // ARCHIVED = 'archived',
  // ON_WAY_TO_DELIVERY = 'on_way_to_delivery',
  // SIGNATURE_REQUESTED = 'signature_requested',
  // DELETED = 'deleted',
  // BILLED = 'billed',
  // CANCELED_CLIENT = 'canceled-client',
}
